module.exports = __webpack_public_path__ + "img/board_btn_a.4027d458.png";